import React from "react";
import "../styles/06-pages/home.scss";
import { FeaturesSection } from "components/FeaturesSection";

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <FeaturesSection />
    </div>
  );
};

export default Home;
